import { Search, Filter } from 'lucide-preact'
import { BRAND_CLASSES } from '@/constants/theme'
import { getDeploymentStatusLabel } from '@/components/webs/constants/deploymentMeta'
import type { DeploymentStatus } from '@/types/landingPage'

interface Props {
  searchQuery: string
  onSearchChange: (value: string) => void
  statusFilter: string
  onStatusChange: (value: string) => void
  availableStatuses: DeploymentStatus[]
}

/**
 * ORB-501: search box + status dropdown for the deployment history grid. Presentational only —
 * the filter state and logic live in useDeploymentSearchFilter. Mirrors AssetFilterBar.
 */
export function DeploymentFilterBar({
  searchQuery, onSearchChange, statusFilter, onStatusChange, availableStatuses,
}: Props) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 mb-3">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none" />
        <input
          type="text"
          placeholder="Search deploy #, content version, status, or error..."
          value={searchQuery}
          onInput={(e) => onSearchChange(e.currentTarget.value)}
          aria-label="Search deployments by deploy number, content version, status, or error text"
          className={`w-full pl-10 pr-4 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-900 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 ${BRAND_CLASSES.FOCUS.PRIMARY} focus:border-transparent`}
        />
      </div>
      <div className="flex items-center gap-2">
        <Filter className="w-4 h-4 text-slate-400 flex-shrink-0" />
        <select
          value={statusFilter}
          onChange={(e) => onStatusChange(e.currentTarget.value)}
          aria-label="Filter deployments by status"
          className={`px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-900 dark:text-white focus:outline-none focus:ring-2 ${BRAND_CLASSES.FOCUS.PRIMARY} focus:border-transparent`}
        >
          <option value="all">All statuses</option>
          {availableStatuses.map((status) => (
            <option key={status} value={status}>{getDeploymentStatusLabel(status)}</option>
          ))}
        </select>
      </div>
    </div>
  )
}
